export default "__VITE_ASSET__e2a2f7ab__"